//#region API
import {API} from '../../api/index.js';

// 1. Get a single survey form template with its questions
export const loadSurveyForm = async (formTypeId, instantId) => {
  const qs = instantId > 0 ? `?instancesId=${instantId}` : '';
  return await API.get("careadmin", `/careadmin/survey-forms/${formTypeId}${qs}`);
};

// 2. Create a new survey instance
export const createSurveyInstance = async (payload) => {
  return await API.post("careadmin", "/careadmin/survey-instances", { body: payload });
};

// 3. Update an existing survey instance
export const updateSurveyInstance = async (instanceId, payload) => {
  // payload can include any updatable fields, e.g. { status, completed_date, customer_overall_rating }
  return await API.put("careadmin", `/careadmin/survey-instances/${instanceId}`, payload);
};
// 4. List all forms (and any existing instance) for a given order & centre
export const loadSurveyFormList = async (centreId, page = 1) => {
  return await API.get("careadmin", `/careadmin/survey-forms?centre_id=${centreId}&page=${page}&volume=20`);
};

// 4. List all forms (and any existing instance) for a given order & centre
export const loadSurveyFormByOrder = async (orderId, centreId) => {
  return await API.get("careadmin", `/careadmin/survey-forms?centre_id=${centreId}&order_id=${orderId}&page=1&volume=20&in_used=true`);
};

// 4. List all forms (and any existing instance) for a given order & centre
export const loadSurveyFormByCg = async (cgId) => {
  return await API.get("careadmin", `/careadmin/survey-forms?caregiver_id=${cgId}&page=1&volume=20&in_used=true&urltype=details,answer,customer`);
};


// 4. List all forms (and any existing instance) for a given order & centre
export const loadSurveyFormByCC = async (ccId) => {
  return await API.get("careadmin", `/careadmin/survey-forms?customer_id=${ccId}&page=1&volume=20&in_used=true&urltype=details,answer,caregiver`);
};

// 5. Submit answers and mark a survey instance completed
export const submitSurveyAnswers = async (instanceId, answers) => {
  // answers should be an array of { survey_question_id, answer_value }
  return await API.post("careadmin", `/careadmin/survey-instances/${instanceId}/answers`,answers);
};

// 6. Create a new survey form template (and its questions)
export const createSurveyForm = async (payload) => {
  return await API.post("careadmin", "/careadmin/survey-forms", { body: payload });
};

// 7. Update an existing survey form template & its questions
export const updateSurveyForm = async (formTypeId, payload) => {
  return await API.put("careadmin", `/careadmin/survey-forms/${formTypeId}`, {body: payload});
};

// 8. List survey instances for analytics or filtering
export const listSurveyInstances = async ({
  startDate,
  endDate,
  customerId,
  caregiverId,
}) => {
  const qs =
    `?start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(
      endDate
    )}` +
    `&customer_id=${encodeURIComponent(
      customerId
    )}&caregiver_id=${encodeURIComponent(caregiverId)}`;
  return await API.get("careadmin", `/survey-instances${qs}`);
};

//#endregion
